<template>
	<div v-if="loaded">
		<header class="card-header">
			<h3 class="card-title">Provider Alternatives Popup</h3>
		</header>
		<div class="card-body">
			<section>
				<div class="flex box">
					<label class="six label-checkbox" for="apopup">
						<input @change="saveAlternatives" id="apopup" name="apopup" type="checkbox" v-model="altEnabled">
						Enable Alternatives PopUp
					</label>
					<label class="six label-checkbox" for="apdefault">
						<input :disabled="!altEnabled" @change="saveAlternatives" id="apdefault" name="apdefault" type="checkbox" v-model="altDefault">
						Use Default Providers
					</label>
				</div>
				<h4 class="card-subtitle" v-if="loaded && altEnabled && !altDefault">Select Alternative Providers</h4>
				<div class="flex box start" v-if="loaded && altEnabled && !altDefault">
					<div class="input-group four">
						<vue-select
								:options="providers"
								@change="saveAlternatives"
								id="alt_providers_0"
								label="name"
								name="providers"
								v-model="altProviders[0]"
						>
						</vue-select>

					</div>
					<div class="input-group four">
						<vue-select
								:options="providers"
								@change="saveAlternatives"
								id="alt_providers_1"
								label="name"
								name="providers"
								v-model="altProviders[1]"
						>
						</vue-select>

					</div>
					<div class="input-group four">
						<vue-select
								:options="providers"
								@change="saveAlternatives"
								id="alt_providers_2"
								label="name"
								name="providers"
								v-model="altProviders[2]"
						>
						</vue-select>
					</div>
				</div>
			</section>
		</div>

	</div>
</template>

<script>
	import VueSelect from '../../../../node_modules/vue-select';
	import Errors from '../../Utils/Errors.js';

	export default {
		components: {
			"vue-select": VueSelect
		},
		props: {
			providerid: {
				type: Number
			}
		},
		data() {
			return {
				tabName: 'commercialAlternatives',
				baseLoaded: false,
				provider: {},
				providerId: this.providerid,

				filtered_providers: [],

				selectedProviderListVSelect: {},
				altProviders: [],
				altDefault: false,
				altEnabled: false,
				loaded: false,

				errors: new Errors(),
			}
		},
		created() {
			this.fetchDataFromApi();
		},
		computed: {
			providers: function () {
				for (let i = 0; i < this.filtered_providers.length; i++) {
					if (this.filtered_providers[i].provider_type_id !== this.selectedProviderType) {
						this.filtered_providers.splice(i, 1);
					}
				}
				return this.filtered_providers;
			}
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('provider')) {
							vm.provider = response.data.provider;
						}
						vm.baseLoaded = true;
						this.loadSameTypeProviders();
					})
					.catch(e => {
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
			loadSameTypeProviders: function (data) {
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/loadsametypeproviders/providers/' + vm.providerId)
					.then(response => {
						this.filtered_providers = response.data.providers;
						this.loadAlternatives();
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Alternative Providers loading failed.', 'Error');
					});
			},

			loadAlternatives: function () {
				let vm = this;

				axios.get('/api/' + vm.$selectedSite.slug + '/loadalternatives/providers/' + vm.providerId)
					.then(response => {
						vm.loadAlternativesVselect(response.data.alternatives);
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Alternatives loading failed.', 'Error');
					});
			},


			saveAlternatives: function () {
				let vm = this;

				let alternatives = vm.altProviders;
				if (!this.altEnabled) {
					alternatives = false;
				}
				if (this.altEnabled && this.altDefault) {
					alternatives = true;
				}

				axios.post('/api/' + vm.$selectedSite.slug + '/savealternatives/providers/' + vm.provider.id,
					{
						alternatives: alternatives
					})
					.then(response => {
						vm.$toastr.success('Alternatives saved successfully', 'Success');
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Alternatives saving failed.', 'Error');
					});
			},

			//convert array to v-select
			loadAlternativesVselect: function (data) {
				if (data === true) {
					this.altEnabled = true;
					this.altDefault = true;
					this.loaded = true;
					return true;
				}
				if (data === false) {
					this.altEnabled = false;
					this.altDefault = false;
					this.loaded = true;
					return true;
				}
				if (data === 'null' || data === null) {
					this.altEnabled = false;
					this.loaded = true;
					return true;
				}
				this.altEnabled = true;
				data.forEach((item, index) => {
					this.providers.forEach((provider, providerIndex) => {
						if (item === provider.id) {
							this.altProviders[index] = this.providers[providerIndex];
							return true;
						}
					});
				});
				this.loaded = true;
			}
			//convert array to v-select
		}
	}
</script>
